export default function Event(props) {
    let tone = 'event-box ' + props.tone
    return (
        <div className={tone}>
            <h3> {props.title} </h3>
            <p> {props.text}</p>
        </div >
    )

}